import { MouseEventHandler } from 'react'
import Slide from '@mui/material/Slide'
import { CustomSnackbar, SnackbarAlert } from './Snackbar.styles'
import { SnackbarProps } from './Snackbar.types'
import { AlertProps } from '../Alert'

const Snackbar = ({
  className = '',
  autoHideDuration = 3000,
  styles,
  closeOnClick = false,
  origin = 'top',
  showIcon = false,
  showCloseButton = false,
  onClick,
  onClose,
  ...props
}: SnackbarProps) => {
  const {
    variant,
    title,
    message,
    severity,
    color,
    icon,
    size,
    align,
    data,
    closeButton,
    ...snackbarProps
  } = props

  const handleClick: MouseEventHandler<HTMLDivElement> = (event) => {
    if (closeOnClick && onClose) {
      onClose(event, 'escapeKeyDown')
    }
    onClick?.(event)
  }

  const closeButtonProps: AlertProps['closeButton'] = showCloseButton
    ? {
        actions: ({ event }) => onClose?.(event, 'escapeKeyDown'),
        iconButton: {},
        ...closeButton
      }
    : undefined

  return (
    <CustomSnackbar
      className={`Snackbar ${className}`}
      anchorOrigin={{ vertical: origin, horizontal: 'center' }}
      sx={styles}
      onClick={handleClick}
      onClose={onClose}
      TransitionComponent={Slide}
      autoHideDuration={autoHideDuration}
      {...snackbarProps}>
      <SnackbarAlert
        title={title}
        message={message}
        severity={severity}
        color={color}
        variant={variant}
        icon={showIcon ? icon : false}
        size={size}
        align={align}
        data={data}
        closeButton={closeButtonProps}
      />
    </CustomSnackbar>
  )
}

export default Snackbar
